import c from 'classnames';
import React from 'react';

import {
  Button,
  ButtonColors,
  GutBodyConnectionsBody,
  TextColor,
  Typography,
} from '@repo/ui';
import useGutBodyProps from 'hooks/useGutBodyProps';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';
import styles from './ConditionsIntro.module.css';
import {
  CONDITIONS_INTRO_SLIDE_ID,
  GENERIC_BODY_ORGANS,
  INTRO_TAGS_OVERLAYS,
  resolveIntroBodyVariant,
} from './conditionsSlides';
import slideStyles from './Slides.module.css';
import { useConditionsSlide } from './useConditionsSlide';

export const ConditionsIntro: React.FC = () => {
  const { age, pregnant, sex } = useGutBodyProps();
  const { isFirstView, viewConditions } = useConditionsSlide({
    slideId: CONDITIONS_INTRO_SLIDE_ID,
  });

  const bodyVariant = resolveIntroBodyVariant({ age, sex, pregnant });
  const tagsOverlay = INTRO_TAGS_OVERLAYS[bodyVariant];

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slide)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.conditionsIntro }}
    >
      <div className={styles.content}>
        <Typography variant='heading-xl' color={TextColor.DARKPURPLE}>
          Microbes and
          <br />
          their functions
          <br />
          are connected to
          <br />
          other areas of your
          <br />
          health.
        </Typography>
      </div>
      <div className={styles.body}>
        <div className={c(styles.bodyInner, styles[bodyVariant])}>
          <GutBodyConnectionsBody
            className={styles.bodyFade}
            showDotAndTooltips={false}
            colorVariant='purple'
            litOrgans={['gut']}
            pulseUnlit
            disableHover
            organs={GENERIC_BODY_ORGANS}
            age={age}
            pregnant={pregnant}
            sex={sex}
          />
          {tagsOverlay && (
            <img
              src={tagsOverlay}
              className={styles.tagsOverlay}
              alt=''
              aria-hidden
            />
          )}
        </div>
      </div>
      {!isFirstView && (
        <div className={styles.buttons}>
          <Button
            variant='outline'
            color={ButtonColors.PURPLE}
            onClick={viewConditions}
          >
            View associated conditions
          </Button>
        </div>
      )}
    </div>
  );
};
